import styled, { css } from 'styled-components';

export const StyledDailyBonus = styled.div`
    :focus-visible {
        outline: none;
    }

    width: 100%;
    height: 100%;

    .daily-bonus-banner {
        font-family: var(--font-family), Arial;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        background-color: ${(props: any) => props?.backgroundColor};
        border-radius: 15px;
        padding: 15px;
        position: relative;
        width: inherit;
        height: inherit;

        ${(props: any) =>
            props.backgroundImage &&
            css`
                background-image: url(${props.backgroundImage});
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
            `}
        &__close-icon {
            padding: 10px;
            position: absolute;
            top: 0;
            right: 0;
            border: unset;
            background: unset;

            &:hover {
                cursor: pointer;
            }
        }

        &__title {
            font-size: ${(props: any) => props?.titleSize};
            font-weight: ${(props: any) => props?.titleWeight};
            color: ${(props: any) => props?.titleColor};
            margin: 33px 0 0;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 100%;
        }

        &__action-button {
            font-size: 20px;
            text-shadow: 0 1px 1px black;
            box-shadow: inset 0 -4px 0 rgba(0, 0, 0, 0.3);

            &--disabled {
                cursor: default;

                img {
                    margin-right: 5px;
                    height: 18px;
                }
            }
        }

        &__product-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: white;

            &__product-amount {
                text-shadow: 0px 1px 1px #000;
                font-size: 20px;
                font-weight: 700;
            }
        }
    }
` as any;
